import { useMemo } from "react";
import classes from "../integrationStyles.module.scss";

/**
 * 
 * @param {*} props
 * detail : string => object key of _details the field is part of
 * index : int => since _details is an array. This tells us to which this field belongs to
 * @returns 
 */
export const BoolField = (props) =>{
    const {fieldName, fieldConfig, onChange, detail, index, ...prop} = props;
    const handleFieldChange= (value, e) =>{
        value = value === "true" ? true : false;
        if(onChange)
            onChange(value, fieldName, {fieldConfig, detail, index, e});
    }
    
    const settings = useMemo(() => {
        return {
            Mandatory : false, 
            Type : "bool",
            Value : null, 
            ...fieldConfig
        }
    }, [fieldConfig])
    return (
        <>
        <select
        name={fieldName}
        className={classes["select1"]}
        required={settings.Mandatory}
        key={fieldName}
        defaultValue={(settings.Value ?  "true" : "false")}
        {...prop}
        onChange={(e) => {
            handleFieldChange(e.target.value, e);
        }}
        >
            <option value={true} key="true">True</option>
            <option value={false} key="false">False</option>
        </select>
        </>
    )
}